// extracted by mini-css-extract-plugin
module.exports = {"scrollButton":"ScrollToTop_scrollButton__RFjPH","visible":"ScrollToTop_visible__mIcd9"};